import { type ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';

import { PrimaryButton } from '../../../../shared/ui';

export type RafflePrimaryButtonProps = ComponentPropsWithoutRef<
  typeof PrimaryButton
>;

const Button = styled(PrimaryButton).attrs({
  'data-ui': 'raffle-primary-button',
})`
  width: ${({ theme }) => theme.scale.px(275)};
  min-height: ${({ theme }) => theme.scale.px(46)};
  justify-self: center;
  border-radius: ${({ theme }) => theme.scale.px(10)};
  font-size: ${({ theme }) => theme.scale.px(15)};
  line-height: ${({ theme }) => theme.scale.px(19)};
`;

export function RafflePrimaryButton(props: RafflePrimaryButtonProps) {
  return <Button {...props} />;
}
